/* Interactive storefront preview controls. No extension runtime is included. */
(function () {
  'use strict';
  const initialized = new WeakSet();
  const routes = ['home', 'sniping-entry', 'sniping-saved', 'bidding-entry', 'bidding-saved',
    'sniping', 'sniping-defaults', 'bidding', 'ranges', 'sbc', 'logs', 'transfer-entry', 'sbc-packs', 'pack', 'selling'];

  function init(demo) {
    if (!demo || initialized.has(demo)) return;
    if (!window.FutpilotPreviewProfiles || !window.FutpilotPreviewSniping || !window.FutpilotPreviewBidding || !window.FutpilotPreviewOther) return;
    initialized.add(demo);
    const shell = demo.querySelector('.af-demo-shell');
    const radio = Object.fromEntries(routes.map(route => [
      route, demo.querySelector('.af-demo-' + route + '-toggle')
    ]));
    let current = routes.find(route => radio[route]?.checked) || 'home';
    let routeCommit = false;
    let feedbackTimer = null;
    let unsavedDialog = null;
    const feedback = document.createElement('div');
    feedback.className = 'afp-feedback';
    feedback.setAttribute('role', 'status');
    feedback.setAttribute('aria-live', 'polite');
    feedback.hidden = true;
    shell.append(feedback);
    function showFeedback(message, tone) {
      feedback.textContent = String(message || '');
      feedback.dataset.tone = tone || 'info';
      feedback.hidden = false;
      clearTimeout(feedbackTimer);
      feedbackTimer = setTimeout(() => { feedback.hidden = true; }, 3600);
    }

    const storage = window.FutpilotPreviewProfiles;
    const sniping = window.FutpilotPreviewSniping.mount(
      demo.querySelector('.af-demo-screen-sniping'),
      demo.querySelector('.af-demo-screen-sniping-defaults'), {
        onNavigate: navigate,
        onFeedback: showFeedback,
        getStored: (kind) => storage.getActive(kind, window.FutpilotPreviewSniping.defaultState()),
        saveStored: (kind, data) => storage.saveActive(kind, data)
      });
    const bidding = window.FutpilotPreviewBidding.mount(
      demo.querySelector('.af-demo-screen-bidding'), {
        onNavigate: navigate,
        onFeedback: showFeedback,
        getStored: (kind) => storage.getActive(kind, window.FutpilotPreviewBidding.defaultState()),
        saveStored: (kind, data) => storage.saveActive(kind, data),
        getActiveKey: kind => storage.getActiveKey(kind),
        onRemoveProfile: (kind, key) => {
          storage.removeProfile(kind, key);
          setRoute('bidding-entry');
        }
      });
    const savedSniping = storage.mount(
      demo.querySelector('.af-demo-screen-sniping-saved .af-demo-saved-menu'), 'sniping', {
        getCurrent: () => sniping.getData(),
        setCurrent: data => sniping.setData(data),
        onEdit: () => navigate('sniping-defaults'),
        onFeedback: showFeedback,
        showEditDefaults: false
      });
    const savedBidding = storage.mount(
      demo.querySelector('.af-demo-screen-bidding-saved .af-demo-saved-menu'), 'bidding', {
        getCurrent: () => bidding.getData(),
        setCurrent: data => bidding.setData(data),
        onEdit: () => navigate('bidding'),
        onFeedback: showFeedback,
        showEditDefaults: false
      });
    const other = window.FutpilotPreviewOther.mount({
      ranges: demo.querySelector('.af-demo-screen-ranges'),
      sbc: demo.querySelector('.af-demo-screen-sbc'),
      logs: demo.querySelector('.af-demo-screen-logs')
    }, { onFeedback: showFeedback });

    window.FutpilotPreviewTools?.mount(demo);
    demo.addEventListener('click', event => {
      const button = event.target.closest('[data-af-demo-route]');
      if (button) navigate(button.dataset.afDemoRoute);
    });
    demo.closest('.af-site')?.addEventListener('click', event => {
      const link = event.target.closest('[data-af-tool-route]');
      if (!link) return;
      navigate(link.dataset.afToolRoute);
      demo.querySelector('.af-demo-screen-' + current + ' button')?.focus({ preventScroll: true });
    });
    function editorFor(route) {
      if (route === 'sniping' || route === 'sniping-defaults') return sniping;
      if (route === 'bidding') return bidding;
      if (['ranges', 'sbc', 'logs'].includes(route)) return {
        hasUnsaved: () => other.hasUnsaved(route),
        save: () => other.save(route),
        revert: () => other.revert(route)
      };
      return null;
    }
    function setRoute(target) {
      if (!radio[target]) return;
      routeCommit = true;
      radio[target].checked = true;
      radio[target].dispatchEvent(new Event('change', { bubbles: true }));
      routeCommit = false;
      current = target;
      feedback.hidden = true;
      if (target === 'sniping-saved') savedSniping.render();
      if (target === 'bidding-saved') savedBidding.render();
      const workspace = demo.querySelector('.af-demo-screen-' + target + ' .af-demo-workspace');
      if (workspace) workspace.scrollTop = 0;
    }
    function closeUnsaved() {
      if (unsavedDialog) unsavedDialog.remove();
      unsavedDialog = null;
    }
    function askUnsaved(target, editor) {
      closeUnsaved();
      const backdrop = document.createElement('div');
      backdrop.className = 'afp-modal-backdrop af-unsaved-overlay';
      backdrop.innerHTML =
        '<section class="afp-modal af-unsaved-dialog" role="alertdialog" aria-modal="true" aria-labelledby="afp-unsaved-title">' +
        '<h2 id="afp-unsaved-title">Unsaved Changes</h2>' +
        '<div class="afp-modal-actions af-unsaved-actions">' +
        '<button type="button" class="afp-button" data-choice="keep"><span class="af-icon af-g-e0c7" aria-hidden="true">\ue0c7</span>Keep Editing</button>' +
        '<button type="button" class="afp-button" data-choice="discard"><span class="af-icon af-g-e0c8" aria-hidden="true">\ue0c8</span>Discard Changes</button>' +
        '<button type="button" class="afp-button afp-button-primary" data-choice="save"><span class="af-icon af-g-e02f" aria-hidden="true">\ue02f</span>Save and Continue</button>' +
        '</div></section>';
      backdrop.addEventListener('click', async event => {
        const choice = event.target.closest('[data-choice]')?.dataset.choice;
        if (!choice) return;
        if (choice === 'discard') { editor.revert(); closeUnsaved(); setRoute(target); }
        else if (choice === 'save') {
          try {
            if (await editor.save() !== false) { closeUnsaved(); setRoute(target); }
          } catch (issue) { showFeedback(issue?.message || 'Could not save these settings.', 'error'); }
        }
        else closeUnsaved();
      });
      backdrop.addEventListener('keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); closeUnsaved(); }
      });
      shell.append(backdrop);
      unsavedDialog = backdrop;
      backdrop.querySelector('[data-choice="keep"]').focus();
    }
    function navigate(target) {
      if (!radio[target] || target === current) return;
      const editor = editorFor(current);
      if (editor?.hasUnsaved?.()) {
        askUnsaved(target, editor);
        return;
      }
      setRoute(target);
    }
    for (const route of routes) if (radio[route]) radio[route].tabIndex = -1;
    for (const label of demo.querySelectorAll('label[for]')) {
      const target = document.getElementById(label.htmlFor);
      if (!target?.classList.contains('af-demo-switch')) continue;
      label.tabIndex = 0;
      label.setAttribute('role', 'button');
    }
    demo.addEventListener('keydown', event => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      const label = event.target.closest('label[for]');
      if (!label || !demo.contains(label)) return;
      const target = document.getElementById(label.htmlFor);
      const name = routes.find(route => target === radio[route]);
      if (!name) return;
      event.preventDefault();
      navigate(name);
    }, true);
    demo.addEventListener('click', event => {
      const label = event.target.closest('label[for]');
      if (!label || !demo.contains(label)) return;
      const target = document.getElementById(label.htmlFor);
      if (!target?.classList.contains('af-demo-switch')) return;
      const name = routes.find(route => target === radio[route]);
      if (!name) return;
      event.preventDefault();
      navigate(name);
    }, true);
    demo.addEventListener('change', event => {
      const route = routes.find(name => event.target === radio[name]);
      if (!route) return;
      if (routeCommit) current = route;
      else if (route !== current) {
        radio[current].checked = true;
        navigate(route);
      }
    });
  }
  function scan() {
    document.querySelectorAll('.af-app-demo').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();
